export const heroButtonClicked = (text, target) => ({
  type: 'Hero Button Clicked',
  data: {
    text,
    target,
  },
});
